import { styled } from "styled-components";

import { Anchor } from "@atlassiansox/bxp-content-framework";

const LogoLink = styled(Anchor)({
    "alignItems": "center",
    "align-items": "center",
    "alignSelf": "stretch",
    "align-self": "stretch",
    "display": "flex",
    "padding": "1rem"
});

export default LogoLink;
